import { sectionTitleTextStyles } from '../OurStoryPage'
import { Section5Images } from '../../../assets/OurStoryImages/Section5'
import Slider from 'react-slick'

export const Section5 = () => {
  const settings = {
    centerMode: true,
    centerPadding: '20px',
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  }

  return (
    <div className='!py-10 !px-5 bg-[rgb(241,255,253)] lg:!px-30'>
      <div className='py-6'>
        <h1 className={`${sectionTitleTextStyles} text-center mb-10`}>
          We have been backed by
        </h1>
        <div className='block md:hidden'>
          <Slider
            {...settings}
            className='bg-white pb-3 pt-4 border border-[#bfefe8]'
          >
            <div className='w-full'>
              <img
                src={Section5Images.BackerLogo1}
                alt='Backer Logo 1'
                className='h-[60px] mx-auto'
              />
            </div>
            <div className='w-full'>
              <img
                src={Section5Images.BackerLogo2}
                alt='Backer Logo 2'
                className='h-[60px] mx-auto'
              />
            </div>
            <div className='w-full'>
              <img
                src={Section5Images.BackerLogo3}
                alt='Backer Logo 3'
                className='h-[60px] mx-auto'
              />
            </div>
            <div className='w-full'>
              <img
                src={Section5Images.BackerLogo4}
                alt='Backer Logo 4'
                className='h-[60px] mx-auto'
              />
            </div>
          </Slider>
        </div>
        {/* Logos in a row for larger screens */}
        <div className='hidden md:flex flex-wrap justify-center gap-10 w-fit mx-auto bg-white p-3 border border-[#bfefe8]'>
          <img
            src={Section5Images.BackerLogo1}
            alt='Backer Logo 1'
            className='h-[60px]'
          />
          <img
            src={Section5Images.BackerLogo2}
            alt='Backer Logo 2'
            className='h-[60px]'
          />
          <img
            src={Section5Images.BackerLogo3}
            alt='Backer Logo 3'
            className='h-[60px]'
          />
          <img
            src={Section5Images.BackerLogo4}
            alt='Backer Logo 4'
            className='h-[60px]'
          />
        </div>
      </div>
    </div>
  )
}
